//@flow
import { connect } from 'react-redux';
import { withProps, compose } from 'react-recompose';
import { CommonActions } from '@react-navigation/native';
import RoamingFrame from './RoamingFrame';
import { setTravelCountry } from '../../../../modules/International/Travel';
import I18n from '../../../../lib/i18n';
import Navigation from '../../../../lib/navigation';
import config from '../../../../config';

const mapDispatchToProps = (dispatch, ownProps) => {
  const zone = ownProps.zone.replace('TRAVEL_ZONE_', '');

  return {
    onPress: () => {
      dispatch(setTravelCountry(config.iddCountries.find(country => country.travelZone === zone)));
      Navigation.dispatch(CommonActions.navigate({ name: 'travelTopUp', params: { hideBodyPage: true } }));
    },
  };
};

const withTravelFrameProps = ownProps => ({
  title: I18n.t('travelPanel.title', { zone: ownProps.zone.replace('TRAVEL_ZONE_', '') }),
  textLink: I18n.t('travelPanel.textLink'),
  displayDonut: true,
});

export default compose(connect(null, mapDispatchToProps), withProps(withTravelFrameProps))(RoamingFrame);
